import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result3t1vadv16kmzk as Result,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  newThrowablezl37abp36p5f as newThrowable,
  protoOf180f3jzyo7rfj as protoOf,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString1h6jjoch8cjt8 as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { stackTraceToString2670q6lbhdojj as stackTraceToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { get_DEVELOPMENT_MODE18ax9b1n971lk as get_DEVELOPMENT_MODE } from './ByteChannel.web.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  ClosedReadChannelException9jdpzh6uy12w as ClosedReadChannelException,
  ClosedWriteChannelException1eeenxj0c4bxu as ClosedWriteChannelException,
} from './Exceptions.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from '../../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { rethrowCloseCauseIfNeededeln8lm5agg4u as rethrowCloseCauseIfNeeded } from './ByteReadChannelOperations.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  numberToLong2pakxeg38estk as numberToLong,
  add2suhfggl4zvkk as add,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  awaitContent$default2jefvu0cvwa0w as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import {
  get_CLOSED3uiwvc5y98ftj as get_CLOSED,
  CloseToken4utf44psnuyc as CloseToken,
} from './CloseToken.mjs';
import { ByteWriteChannel3jkhlhzuuoxp1 as ByteWriteChannel } from './ByteWriteChannel.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.m4i_1 = new (Closed())(null);
        var tmp = this;
        // Inline function 'kotlin.Companion.success' call
        tmp.n4i_1 = _Result___init__impl__xyqfz8(Unit_instance);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var EmptyClass;
function Empty() {
  if (EmptyClass === VOID) {
    class $ {
      toString() {
        return 'Empty';
      }
      hashCode() {
        return -231472095;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Empty()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Empty');
    EmptyClass = $;
  }
  return EmptyClass;
}
var Empty_instance;
function Empty_getInstance() {
  return Empty_instance;
}
var ClosedClass;
function Closed() {
  if (ClosedClass === VOID) {
    class $ {
      constructor(cause) {
        this.o4i_1 = cause;
      }
      toString() {
        return 'Closed(cause=' + toString(this.o4i_1) + ')';
      }
      hashCode() {
        return this.o4i_1 == null ? 0 : hashCode(this.o4i_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Closed()))
          return false;
        if (!equals(this.o4i_1, other.o4i_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Closed');
    ClosedClass = $;
  }
  return ClosedClass;
}
function resume() {
  return this.q4i().oc(Companion_getInstance().n4i_1);
}
function resume_0(throwable) {
  var tmp = this.q4i();
  var tmp_0;
  if (throwable == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(throwable));
    tmp_0 = new (Result())(tmp$ret$0);
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp.oc(tmp1_elvis_lhs == null ? Companion_getInstance().n4i_1 : tmp1_elvis_lhs.kt_1);
}
var TaskClass;
function Task() {
  if (TaskClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Task');
    TaskClass = $;
  }
  return TaskClass;
}
var ReadClass;
function Read() {
  if (ReadClass === VOID) {
    class $ {
      constructor(continuation) {
        this.u4i_1 = continuation;
        this.v4i_1 = null;
        if (get_DEVELOPMENT_MODE()) {
          var tmp = this;
          // Inline function 'kotlin.also' call
          var this_0 = newThrowable('ReadTask 0x' + toString_0(hashCode(this.u4i_1), 16));
          stackTraceToString(this_0);
          tmp.v4i_1 = this_0;
        }
      }
      q4i() {
        return this.u4i_1;
      }
      p4i() {
        return this.v4i_1;
      }
      r4i() {
        return 'read';
      }
    }
    protoOf($).s4i = resume;
    protoOf($).t4i = resume_0;
    initMetadataForClass($, 'Read', VOID, VOID, [Task()]);
    ReadClass = $;
  }
  return ReadClass;
}
var WriteClass;
function Write() {
  if (WriteClass === VOID) {
    class $ {
      constructor(continuation) {
        this.w4i_1 = continuation;
        this.x4i_1 = null;
        if (get_DEVELOPMENT_MODE()) {
          var tmp = this;
          // Inline function 'kotlin.also' call
          var this_0 = newThrowable('WriteTask 0x' + toString_0(hashCode(this.w4i_1), 16));
          stackTraceToString(this_0);
          tmp.x4i_1 = this_0;
        }
      }
      q4i() {
        return this.w4i_1;
      }
      p4i() {
        return this.x4i_1;
      }
      r4i() {
        return 'write';
      }
    }
    protoOf($).s4i = resume;
    protoOf($).t4i = resume_0;
    initMetadataForClass($, 'Write', VOID, VOID, [Task()]);
    WriteClass = $;
  }
  return WriteClass;
}
function moveFlushToReadBuffer($this) {
  // Inline function 'io.ktor.utils.io.locks.synchronized' call
  $this.b4j_1;
  $this.z4i_1.m4g($this.d4j_1);
  $this.a4j_1 = 0;
  // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
  var current = $this.c4j_1.kotlinx$atomicfu$value;
  var tmp;
  if (current instanceof Write()) {
    tmp = $this.c4j_1.atomicfu$compareAndSet(current, Empty_instance);
  } else {
    tmp = false;
  }
  if (tmp) {
    current.s4i();
  }
}
function closeSlot($this, cause) {
  var closeContinuation = !(cause == null) ? new (Closed())(cause) : Companion_getInstance().m4i_1;
  var continuation = $this.c4j_1.atomicfu$getAndSet(closeContinuation);
  if (isInterface(continuation, Task())) {
    continuation.t4i(cause);
  }
}
function ClosedReadChannelException$_init_$ref_ix0089() {
  var l = (p0) => ClosedReadChannelException().k4j(p0);
  l.callableName = '<init>';
  return l;
}
function ClosedWriteChannelException$_init_$ref_ef15ty() {
  var l = (p0) => ClosedWriteChannelException().p4j(p0);
  l.callableName = '<init>';
  return l;
}
var ByteChannelClass;
function ByteChannel() {
  if (ByteChannelClass === VOID) {
    class $ {
      constructor(autoFlush) {
        autoFlush = autoFlush === VOID ? false : autoFlush;
        this.y4i_1 = autoFlush;
        this.z4i_1 = new (Buffer())();
        this.a4j_1 = 0;
        this.b4j_1 = new Object();
        this.c4j_1 = atomic$ref$1(Empty_instance);
        this.d4j_1 = new (Buffer())();
        this.e4j_1 = new (Buffer())();
        this.f4j_1 = atomic$ref$1(null);
      }
      q4j() {
        return this.y4i_1;
      }
      r4j() {
        var tmp0_safe_receiver = this.f4j_1.kotlinx$atomicfu$value;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.t4j(ClosedReadChannelException$_init_$ref_ix0089());
        }
        if (this.d4j_1.q3y()) {
          moveFlushToReadBuffer(this);
        }
        return this.d4j_1;
      }
      u4j() {
        if (this.v4j()) {
          var tmp0_safe_receiver = this.f4j_1.kotlinx$atomicfu$value;
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            tmp = tmp0_safe_receiver.t4j(ClosedWriteChannelException$_init_$ref_ef15ty());
          }
          if (tmp == null)
            throw ClosedWriteChannelException().p4j();
        }
        return this.e4j_1;
      }
      w4j() {
        var tmp0_safe_receiver = this.f4j_1.kotlinx$atomicfu$value;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x4j();
      }
      v4j() {
        return !(this.f4j_1.kotlinx$atomicfu$value == null);
      }
      y4j() {
        return !(this.w4j() == null) || (this.v4j() && this.a4j_1 === 0 && this.d4j_1.q3y());
      }
      *z4j(min, $completion) {
        rethrowCloseCauseIfNeeded(this);
        if (this.d4j_1.q2() >= fromInt(min))
          return true;
        // Inline function 'io.ktor.utils.io.ByteChannel.sleepWhile' call
        var this_0 = this;
        $l$loop: while (add(numberToLong(this.a4j_1), this.d4j_1.q2()) < fromInt(min) && this.f4j_1.kotlinx$atomicfu$value == null) {
          // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
          // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
          (yield () => {
            var uCont = $completion;
            var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
            cancellable.b11();
            var tmp0 = this_0;
            var tmp2 = new (Read())(cancellable);
            $l$block_0: {
              // Inline function 'io.ktor.utils.io.ByteChannel.trySuspend' call
              var previous = tmp0.c4j_1.kotlinx$atomicfu$value;
              if (!(previous instanceof Closed())) {
                if (!tmp0.c4j_1.atomicfu$compareAndSet(previous, tmp2)) {
                  tmp2.s4i();
                  break $l$block_0;
                }
              }
              if (previous instanceof Read()) {
                previous.t4i(ConcurrentIOException().e4k(tmp2.r4i(), previous.p4i()));
              } else {
                if (isInterface(previous, Task())) {
                  previous.s4i();
                } else {
                  if (previous instanceof Closed()) {
                    tmp2.t4i(previous.o4i_1);
                    break $l$block_0;
                  } else {
                    if (!equals(previous, Empty_instance)) {
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
              if (!(add(numberToLong(this.a4j_1), this.d4j_1.q2()) < fromInt(min) && this.f4j_1.kotlinx$atomicfu$value == null)) {
                // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
                var current = tmp0.c4j_1.kotlinx$atomicfu$value;
                var tmp;
                if (current instanceof Read()) {
                  tmp = tmp0.c4j_1.atomicfu$compareAndSet(current, Empty_instance);
                } else {
                  tmp = false;
                }
                if (tmp) {
                  current.s4i();
                }
              }
            }
            return cancellable.ly();
          });
        }
        if (this.d4j_1.q2() < 1048576n) {
          moveFlushToReadBuffer(this);
        }
        return this.d4j_1.q2() >= fromInt(min);
      }
      *g4k($completion) {
        rethrowCloseCauseIfNeeded(this);
        this.h4k();
        if (this.a4j_1 < 1048576)
          return Unit_instance;
        // Inline function 'io.ktor.utils.io.ByteChannel.sleepWhile' call
        var this_0 = this;
        $l$loop: while (this.a4j_1 >= 1048576 && this.f4j_1.kotlinx$atomicfu$value == null) {
          // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
          // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
          (yield () => {
            var uCont = $completion;
            var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
            cancellable.b11();
            var tmp0 = this_0;
            var tmp2 = new (Write())(cancellable);
            $l$block_0: {
              // Inline function 'io.ktor.utils.io.ByteChannel.trySuspend' call
              var previous = tmp0.c4j_1.kotlinx$atomicfu$value;
              if (!(previous instanceof Closed())) {
                if (!tmp0.c4j_1.atomicfu$compareAndSet(previous, tmp2)) {
                  tmp2.s4i();
                  break $l$block_0;
                }
              }
              if (previous instanceof Write()) {
                previous.t4i(ConcurrentIOException().e4k(tmp2.r4i(), previous.p4i()));
              } else {
                if (isInterface(previous, Task())) {
                  previous.s4i();
                } else {
                  if (previous instanceof Closed()) {
                    tmp2.t4i(previous.o4i_1);
                    break $l$block_0;
                  } else {
                    if (!equals(previous, Empty_instance)) {
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
              if (!(this.a4j_1 >= 1048576 && this.f4j_1.kotlinx$atomicfu$value == null)) {
                // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
                var current = tmp0.c4j_1.kotlinx$atomicfu$value;
                var tmp;
                if (current instanceof Write()) {
                  tmp = tmp0.c4j_1.atomicfu$compareAndSet(current, Empty_instance);
                } else {
                  tmp = false;
                }
                if (tmp) {
                  current.s4i();
                }
              }
            }
            return cancellable.ly();
          });
        }
        return Unit_instance;
      }
      h4k() {
        if (this.e4j_1.q3y())
          return Unit_instance;
        // Inline function 'io.ktor.utils.io.locks.synchronized' call
        this.b4j_1;
        var count = convertToInt(this.e4j_1.q2());
        this.z4i_1.y4g(this.e4j_1);
        this.a4j_1 = this.a4j_1 + count | 0;
        // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
        var current = this.c4j_1.kotlinx$atomicfu$value;
        var tmp;
        if (current instanceof Read()) {
          tmp = this.c4j_1.atomicfu$compareAndSet(current, Empty_instance);
        } else {
          tmp = false;
        }
        if (tmp) {
          current.s4i();
        }
      }
      l6() {
        this.h4k();
        if (!this.f4j_1.atomicfu$compareAndSet(null, get_CLOSED()))
          return Unit_instance;
        closeSlot(this, null);
      }
      *i4k($completion) {
        // Inline function 'kotlin.runCatching' call
        var tmp;
        try {
          yield* this.g4k($completion);
          // Inline function 'kotlin.Companion.success' call
          tmp = _Result___init__impl__xyqfz8(Unit_instance);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var e = $p;
            // Inline function 'kotlin.Companion.failure' call
            tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        if (!this.f4j_1.atomicfu$compareAndSet(null, get_CLOSED()))
          return Unit_instance;
        closeSlot(this, null);
        return Unit_instance;
      }
      j4k(cause) {
        if (!(this.f4j_1.kotlinx$atomicfu$value == null))
          return Unit_instance;
        var closedToken = new (CloseToken())(cause);
        this.f4j_1.atomicfu$compareAndSet(null, closedToken);
        var wrappedCause = closedToken.x4j();
        closeSlot(this, wrappedCause);
      }
      toString() {
        return 'ByteChannel[' + hashCode(this) + ']';
      }
    }
    protoOf($).f4k = awaitContent$default;
    initMetadataForClass($, 'ByteChannel', ByteChannel, VOID, [ByteReadChannel(), ByteWriteChannel()], [1, 0]);
    ByteChannelClass = $;
  }
  return ByteChannelClass;
}
var ConcurrentIOExceptionClass;
function ConcurrentIOException() {
  if (ConcurrentIOExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static e4k(taskName, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.q('Concurrent ' + taskName + ' attempts', cause);
        captureStack($this, $this.d4k_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ConcurrentIOException');
    ConcurrentIOExceptionClass = $;
  }
  return ConcurrentIOExceptionClass;
}
//region block: init
Empty_instance = new (Empty())();
//endregion
//region block: exports
export {
  ByteChannel as ByteChannel3cxdguezl3lu7,
};
//endregion

//# sourceMappingURL=ByteChannel.mjs.map
